import { Helmet } from "react-helmet-async";

const SITE_URL = process.env.REACT_APP_SITE_URL;

/**
 * Sayfa bazlı SEO: title, description, canonical, OpenGraph/Twitter (metin) ve JSON-LD.
 *
 * Marka-sabiti etiketler (og:image, og:type, og:site_name, twitter:card, twitter:image)
 * index.html içinde STATİK tutulur — böylece JS çalıştırmayan sosyal tarayıcılar (WhatsApp/FB)
 * da marka önizlemesi görür. Buradaki helmet etiketleri sayfaya ÖZEL ve TEK kez basılır;
 * statikle çakışmaması için bu bileşen og:image/og:type/twitter:card BASMAZ.
 */
export const Seo = ({ title, description, path = "", jsonLd }) => {
  const origin = SITE_URL || (typeof window !== "undefined" ? window.location.origin : "");
  const url = origin + (path || (typeof window !== "undefined" ? window.location.pathname : ""));
  const fullTitle = title ? `${title} | Ertan Kasap` : "Ertan Kasap | İyi Et Tesadüf Değildir";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export default Seo;
